import { useState } from 'react'
import { Button, Typography, Box } from '@material-ui/core'
import DeleteOutlineOutlined from 'components/material-symbol/icons/DeleteOutline'
import { DetailSection } from 'pages/pga-coach/students/student-show-page/details-components/content-box'
import { useStyles } from '../styles'
import DeleteLeadDialog from 'components/delete-lead-dialog'

export default function DeleteLead({ lead }) {
  const [isDeleteLeadDialogOpen, setIsDeleteLeadDialogOpen] = useState(false)
  const classes = useStyles()

  return (
    <DetailSection title="Delete lead" layout="plain" compact>
      <Box className={classes.deleteLead}>
        <Typography className={classes.deleteText}>
          Delete lead, including all data such as messages and contact
          information.
        </Typography>
        <Button
          startIcon={<DeleteOutlineOutlined />}
          variant="outlined"
          color="primary"
          className={classes.deleteActionButton}
          onClick={() => setIsDeleteLeadDialogOpen(true)}
          data-testid="delete-lead-button"
        >
          Delete
        </Button>
        <DeleteLeadDialog
          lead={lead}
          open={isDeleteLeadDialogOpen}
          setOpen={setIsDeleteLeadDialogOpen}
        />
      </Box>
    </DetailSection>
  )
}
